module.exports = __webpack_public_path__ + "media/images/flags/HN-10da3bef388fbdd18c57dae6d3e357c8.svg";